import { HttpClient } from './HttpClient';

export class ContactApi {
  static async send(title: string, content: string): Promise<void> {
    await HttpClient.getInstance().post('/contact', {
      title: `${title}`,
      message: `${content}`,
    });
  }
}
